import React from 'react';
import { Modal } from 'react-bootstrap';

import './modals.style.css';

interface Props {
  isShow: boolean;
  title: string;
  children?: React.ReactElement;
  onHide: () => void;
}

export class TopModal extends React.Component<Props> {
  render() {
    const { isShow, onHide, title, children } = this.props;

    return (
      <Modal className="modal-top" size="xl" show={isShow} onHide={onHide}>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ flexGrow: 1 }}>{children}</Modal.Body>
      </Modal>
    );
  }
}
